import { Application } from "@hotwired/stimulus"
import EmailConfirmController from "./email_confirm_controller.js"
import NoPasteController from "./no_paste_controller.js"
import RevealController from "./reveal_controller.js"
import TimezoneController from "./timezone_controller.js"

const application = Application.start()
application.debug = false
window.Stimulus = application

application.register("email-confirm", EmailConfirmController)
application.register("no-paste", NoPasteController)
application.register("reveal", RevealController)
application.register("timezone", TimezoneController)

export { application }
